module.exports = __webpack_public_path__ + "img/bg_big_tree.ac40d7c3.jpg";